import { Link } from "react-router-dom";
import OuterCircleSvg from "./svg/OuterCircleSvg";
import ArrowIcon from "./svg/ArrowIcon";

type LearnMoreButtonProps = {
  link: string;
};

const LearnMoreButton: React.FC<LearnMoreButtonProps> = ({ link }) => {
  return (
    <div className="services-btn">
      <Link className="primary-btn5" to={link}>
        <OuterCircleSvg />
        <div className="content">
          Learn More
          <span>
            <ArrowIcon />
          </span>
        </div>
      </Link>
    </div>
  );
};

export default LearnMoreButton;
